import {Chip} from "@material-ui/core";
import PropTypes from 'prop-types';
import styled from "styled-components"
import ActionMenu from "./ActionMenu";
import Option from "../SelectionCriteria/Options/Option";
import React, {useContext} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {SelectionCriteriaContext} from "../SelectionCriteria/SelectionCriteriaContext";

const StyledContainer = styled.div`
    padding: 3px;
    display: flex;

    &:hover #advancedFilter_actionMenu {
        visibility: visible;
        display: flex;
        align-items: center;
        justify-content: center;
    }
`
const useStyles = makeStyles((theme) => ({
    filterHeaderWrapper: {
        display: 'flex',
        padding: '6px 5px 6px 5px',
        background: theme.palette.background.default
    },
    filterHeader: {
        width: 130,
        fontSize: 16
    },
    filterBodyWrapper: {
        display: 'flex', margin: '0', padding: '0 5px',
        height: 30
    },
    filterDivider: {
        margin: '0 0 5px 0'
    },
    chipRoot: {height: 'auto', justifyContent: 'flex-start'}
}));
const FilterItem = (props) => {
    const {path, item, index, firstDisabledValue} = props;
    const isPredefinedRequired = props.item?.field?.predefinedRequired;
    const classes = useStyles();
    const {type} = useContext(SelectionCriteriaContext)
    return (
        <StyledContainer>
            <ActionMenu
                path={path}
                index={index}
                isPredefinedRequired={isPredefinedRequired}
            />
            <Chip
                classes={{root: classes.chipRoot}}
                label={<div className={classes.filterBodyWrapper}>
                    <Option
                        path={path}
                        field={item}
                        index={index}
                        firstDisabledValue={firstDisabledValue}
                    />
                </div>}
                variant={"outlined"}
                style={{
                    width: '100%',
                    borderColor: '#eaeaea'
                }}
            />
            {type === 'system' && (
               <>
                   {/*<SbParams/>*/}
               </>
            )}

        </StyledContainer>
    )
};
export default FilterItem

FilterItem.propTypes = {
    path: PropTypes.string
}


